"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _excluded = ["handleSubmit"];
var Form = function Form(_ref) {
  var defaultValues = _ref.defaultValues,
    onSubmit = _ref.onSubmit,
    children = _ref.children,
    className = _ref.className;
  var _useForm = (0, _reactHookForm.useForm)({
      defaultValues: defaultValues
    }),
    handleSubmit = _useForm.handleSubmit,
    rest = (0, _objectWithoutProperties2.default)(_useForm, _excluded);
  return /*#__PURE__*/_react.default.createElement("form", {
    className: className,
    onSubmit: handleSubmit(onSubmit)
  }, children(rest, _reactHookForm.Controller));
};
Form.propTypes = {
  defaultValues: _propTypes.default.objectOf(_propTypes.default.any).isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  children: _propTypes.default.func.isRequired,
  className: _propTypes.default.string
};
Form.defaultProps = {
  className: ''
};
var _default = exports.default = Form;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan-v2/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');